import React from 'react';

const AccordionContent = ({ statusAccordion, children }) => (statusAccordion && (
<div className="accordion-content">
  {children}
</div>
)
);

export default AccordionContent;
